module.exports = __webpack_public_path__ + "img/print.1e2c6a10.png";